var map = {
	"./3.png": "c2e4",
	"./404.png": "16f4",
	"./CODE.png": "dd7f",
	"./JST/course1.png": "6837",
	"./JST/course2.png": "e225",
	"./JST/course3.png": "cc80",
	"./JST/course4.png": "1275",
	"./QUALITY.png": "f244",
	"./SALES.png": "6839",
	"./afterSale.png": "32f1",
	"./appreciate.png": "0077",
	"./appreciateAgreementBackground.png": "1a34",
	"./appreciateCode.png": "fb03",
	"./appreciateLogin.png": "6d38",
	"./appreciateLoginBackground.png": "7e51",
	"./appreciatePhone.png": "3039",
	"./appreciateRegister.png": "cfe6",
	"./appreciateTitle.png": "4614",
	"./arrow.png": "c5d4",
	"./b9fdb6e89da4b215e18f34262ea0cca.png": "d50a",
	"./backTop.png": "e6d6",
	"./barcode.png": "715c",
	"./download_logo.png": "1976",
	"./dyLogin.png": "ae48",
	"./fall.png": "57b7",
	"./goldProductDetail/LOGO.png": "fd81",
	"./goldProductDetail/Recycling.png": "94fb",
	"./goldProductDetail/account_qrcode.png": "f49f",
	"./goldProductDetail/advantage.png": "8dd6",
	"./goldProductDetail/advantage_desc.png": "6756",
	"./goldProductDetail/app_qrcode.png": "4a0d",
	"./goldProductDetail/arrow-right-bottom.png": "d22d",
	"./goldProductDetail/introduction.png": "bf8e",
	"./goldProductDetail/location.png": "7e38",
	"./goldProductDetail/phone.png": "246f",
	"./goldProductDetail/recycling_float.png": "cf67",
	"./goldProductDetail/recyleContent.png": "bfc4",
	"./goldProductDetail/up.png": "d32c",
	"./id.png": "a2a9",
	"./lock-on.png": "c176",
	"./loginLogo.png": "ed65",
	"./logisticsPDF/lock-on.png": "93be",
	"./logo-android.png": "345d",
	"./logo-apple-filled.png": "8148",
	"./logo.png": "cf05",
	"./market.png": "44fa",
	"./metalRecycling.png": "16c0",
	"./metalSale.png": "7cc5",
	"./mobile.png": "978f",
	"./padApp/android_btn.png": "f6ba",
	"./padApp/ios_btn.png": "d212",
	"./padApp/pad_banner.png": "eec2",
	"./padApp/pad_icon_1.png": "1fd9",
	"./padApp/pad_icon_2.png": "7b36",
	"./padApp/pad_icon_3.png": "776b",
	"./padApp/pad_icon_4.png": "ebc0",
	"./pad_banner.png": "7b34",
	"./play-btn.png": "da4c",
	"./recycle.png": "9507",
	"./rise.png": "52fe",
	"./share.png": "75e1",
	"./sixia.png": "cadf",
	"./sourceProduct.png": "89fd",
	"./stone.png": "22fe",
	"./trial/consult-phone.png": "de9e",
	"./wxLogin.png": "a858",
	"./wxshare.png": "2700"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9e01";